module.exports = __webpack_public_path__ + "static/media/icn_ongoingcovid_fisdom.65f9d7c1.svg";